<template>
  <div
    v-if="show"
    class="map-info-window"
    @mousedown="startDrag"
    @mousemove="onDrag"
    @mouseup="stopDrag"
    @mouseleave="stopDrag"
    :style="windowStyle"
  >
    <div class="info-window-header">
      <span>{{ title }}</span>
      <v-btn icon small @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <CircularCalculationStateLoader :calculationState="calculationState" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import CircularCalculationStateLoader from "./CircularCalculationStateLoader.vue";
export default {
  name: "DraggableInfoWindow",
  components: {
    CircularCalculationStateLoader,
  },
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "Calculation Progress",
    },
    initialPosition: {
      type: Object,
      default: () => ({ x: 20, y: 450 }),
    },
  },
  data() {
    return {
      isDragging: false,
      dragOffset: { x: 0, y: 0 },
      windowPosition: { ...this.initialPosition },
      windowSize: { width: 300, height: 200 },
    };
  },
  computed: {
    ...mapState("weatherRouting/formModule", ["calculationState"]),
    windowStyle() {
      return {
        left: `${this.windowPosition.x}px`,
        top: `${this.windowPosition.y}px`,
      };
    },
  },
  methods: {
    startDrag(event) {
      if (event.target.closest(".info-window-header")) {
        this.isDragging = true;
        this.dragOffset = {
          x: event.clientX - this.windowPosition.x,
          y: event.clientY - this.windowPosition.y,
        };
      }
    },
    onDrag(event) {
      if (this.isDragging) {
        const newPosition = {
          x: event.clientX - this.dragOffset.x,
          y: event.clientY - this.dragOffset.y,
        };

        this.windowPosition = this.restrictToBoundaries(newPosition);
      }
    },
    restrictToBoundaries(position) {
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      const restrictedX = Math.max(
        0,
        Math.min(position.x, viewportWidth - this.windowSize.width)
      );

      const restrictedY = Math.max(
        0,
        Math.min(position.y, 0.92 * viewportHeight - this.windowSize.height)
      );

      return {
        x: restrictedX,
        y: restrictedY,
      };
    },
    stopDrag() {
      this.isDragging = false;
    },
  },
};
</script>

<style scoped>
.map-info-window {
  position: absolute;
  width: 300px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  user-select: none;
}

.info-window-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: #1976d2;
  color: white;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  cursor: move;
}

.info-window-header span {
  font-weight: 500;
  font-size: 16px;
}

.info-window-content {
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.info-window-content p {
  margin: 8px 0;
  font-size: 14px;
  color: #333;
}

.info-window-header .v-btn {
  color: white;
}
</style> 